import { render, staticRenderFns } from "./UsageTermsTableItem.vue?vue&type=template&id=13888dbb&scoped=true"
import script from "./UsageTermsTableItem.vue?vue&type=script&lang=js"
export * from "./UsageTermsTableItem.vue?vue&type=script&lang=js"
import style0 from "./UsageTermsTableItem.vue?vue&type=style&index=0&id=13888dbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13888dbb",
  null
  
)

export default component.exports